<header class="topbar">
    <nav class="navbar top-navbar navbar-expand-md navbar-light">
        <div class="navbar-header center">
            <img src="assets/images/temporary-logo.png" class="navbar-brand light-logo" alt="homepage" />
        </div>
        <div class="navbar-collapse">
            <div class="navbar-nav me-auto">
                <a class="nav-link nav-toggler hidden-md-up menulist" href="javascript:void(0)" (click)="toggleMobileMenu()"><i class="bi bi-list"></i></a>
            </div>
            <ul class="navbar-nav my-lg-0">
                <li class="nav-item notification-container">
                    <div class="nav-link bell-container">
                        <i class="bi bi-bell-fill icon-size"></i>
                        <div id="newNoti" class="noti-count">10</div>
                    </div>
                </li>
                <li class="nav-item dropdown right-20">
                    <a class="nav-link dropdown-toggle waves-effect waves-dark profile-pic" href="#" id="navbarDropdown"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        <div class="bg-profile" [ngClass]="'bg-outline-green'"><img src="assets/images/user-profile.jpg" alt="user" class="img-profile"></div>
                        <span class="hidden-md-down profile-name">{{fullName}} &nbsp;</span>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right drp-notification animated bounceInDown">
                        <ul class="dropdown-user">
                            <li>
                                <a [routerLink]="'/profile/myProfile'" routerLinkActive="active" class="profile-li font-12"><i class="bi bi-person"></i> My Profile</a>
                            </li>
                            <li>
                                <a href="#" class="profile-li font-12"><i class="bi bi-key" (click)="signOut()"></i> Sign Out</a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
    <div class="mobile-menu" *ngIf="isMobileMenuOpen">
        <ul *ngIf="isMobile">
            <li *ngFor="let item of mobileMenuItems">
                <div class="menu-item-container" (click)="item.showSubmenu = !item.showSubmenu">
                    <img [src]="item.icon" class="menu-icon" alt="{{ item.name }} icon" />
                    <span class="menu-name">{{ item.name }}</span>
                    <i *ngIf="item.submenuitem" class="submenu-toggle-icon bi"
                        [ngClass]="{'bi-chevron-down': !item.showSubmenu, 'bi-chevron-up': item.showSubmenu}"></i>
                </div>
                <ul *ngIf="item.showSubmenu" class="submenu">
                    <li *ngFor="let sub of item.submenuitem" (click)="setActiveMenuItem(sub)">
                        <a>{{ sub.name }}</a>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</header>
<app-spinner [state]="loading"></app-spinner>